

import moment from 'moment';
import React from 'react';
import close from '../assets/images/close.svg';

const MembershipConfirmPopup = (props) => {
    const { ClosePopup, ConfirmPopup, newMembershipDetail } = props
    return (
        <div className="delete_popup_wrapper">
            {/* <span className="popup_overlay"></span> */}
            <div className="popup_inner">
                <h2 className="popup_title text_center relative">
                    Confirm Membership Change
                    <img src={close} onClick={() => ClosePopup()} />
                </h2>
                <div className="details">
                    <h3 className="detail_title text_center mb_15">Are you sure you want to make this change?</h3>
                    <h3 className="detail_title_bold text_center pb_10">User Email : <span className='text_reset'>{newMembershipDetail.email}</span></h3>
                    <h3 className="detail_title_bold text_center pb_10">Current Membership : <span className='text_reset'>{newMembershipDetail.currentMembershipName ? newMembershipDetail.currentMembershipName : 'none' }</span></h3>
                    <h3 className="detail_title_bold text_center pb_10">New Membership : <span className='text_reset'>{newMembershipDetail.newMembershipName}</span></h3>
                    <h3 className="detail_title_bold text_center pb_10">Payment Method :  <span className='text_reset'>{newMembershipDetail.paymentMethod}</span></h3>
                    <h3 className="detail_title_bold text_center pb_25">Membership Expiration Date : <span className='text_reset'>{moment(newMembershipDetail.cancelDate).format('MM/DD/YYYY')}</span></h3>
                    <div className="content_management">
                        <div className="field_row text_center">
                            <button className="grayBTN " type="button" onClick={() => ClosePopup()}>NO</button>
                            <button className=" orangeBTN active" type="button" onClick={() => ConfirmPopup()}>YES</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MembershipConfirmPopup